import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function FormCompleteModal() {
    const navi = useNavigate();
  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title brand-purple">Form complete</h5>

            </div>

            <div className="modal-body">

              <h4 className="text-center mb-3 brand-dark-purple">
                Your details have been saved
              </h4>

              <p className="text-center mb-4 brand-dark-purple">
                The details you have entered will be used to build your website. We will turn your form into a professional website layout, then you can review it before it goes live.
              </p>

              <div className="p-3 custom-card-light rounded mb-3">
                <p className="mb-1 brand-dark-purple"><strong>What happens next:</strong></p>
                <ul className="mb-0">
                  <li>We use your form details to create your website pages and content</li>
                  <li>You can preview the website before it is published</li>
                  <li>You can request changes once the first version is ready</li>
                </ul>
              </div>

              <div className="p-3 custom-card rounded mb-3">
        
                <p className="mb-0 brand-dark-purple">
                   Your website will be created using the information you provided.
                </p>
              </div>

         

            </div>

            <div className="modal-footer">
        
              <button className="btn brand-purple-inline" onClick={() => navi("/")}>
                Continue
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
